import React from 'react';
import { useEntraAuth } from './EntraAuthProvider';

export const EntraLoginButton = ({ onLoginSuccess, onLoginError, children }) => {
    const { login, loading } = useEntraAuth();

    const handleLogin = async (e) => {
        e.preventDefault();
        e.stopPropagation();

        console.log('🔘 Login button clicked!');
        console.log('Login function available:', typeof login);
        console.log('Loading state:', loading);

        try {
            console.log('Calling login()...');
            const result = await login();
            console.log('Login() result:', result);
            console.log('Login() completed successfully');
            if (onLoginSuccess) {
                onLoginSuccess();
            }
        } catch (error) {
            console.error('❌ Login button error:', error);
            console.error('Error details:', error.message, error.stack);
            if (onLoginError) {
                onLoginError(error);
            }
        }
    };

    return (
        <button
            type="button"
            onClick={handleLogin}
            disabled={loading}
            style={{
                width: '100%',
                padding: '0.75rem',
                background: '#667eea',
                color: 'white',
                border: 'none',
                borderRadius: '5px',
                fontSize: '1rem',
                fontWeight: '600',
                cursor: loading ? 'not-allowed' : 'pointer',
                transition: 'background 0.3s',
                opacity: loading ? 0.6 : 1,
            }}
            onMouseOver={(e) => {
                if (!loading) e.target.style.background = '#5a67d8';
            }}
            onMouseOut={(e) => {
                if (!loading) e.target.style.background = '#667eea';
            }}
        >
            {loading ? 'Signing in...' : (children || 'Sign In with Microsoft')}
        </button>
    );
};
